import script from "./PatientWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientWorkspace.vue?vue&type=script&setup=true&lang=js"

import "./PatientWorkspace.vue?vue&type=style&index=0&id=a797a91e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a797a91e"]])

export default __exports__